import React from 'react';
import ActivityComponent from '../../ppgf/components/activity';
import Banner from '../components/banner';
import ErrorComponent from '../components/partnerError';

const activityData = $('body').data();
var notLoading = true;
export default class PartnerActivity extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			activityData:activityData.body
		}
	}

    render() {
		const error = this.state.activityData.errorType;
		if(!error){
	    return (
				<div>
					<Banner charityName  = {this.state.activityData.charityName} pageName={activityData.body.pageName}/>
					<ActivityComponent flowType='partner'/>
				</div>
			);
		} else {
			return (<div><ErrorComponent errorType={error}/></div>);
		}
	}
}



// WEBPACK FOOTER //
// ./partner/components/activity.js